export default __webpack_public_path__ + "static/realWorldImg4-470864dc7968b4e7ac213c61385376c1.png";